export enum Agency {
  NONE,
  TRANSUNION,
  EQUIFAX,
}
